module.exports = __webpack_public_path__ + "img/double_05.159f6a44.jpg";